import React from "react";
import { Link } from "react-router-dom";
import { Cpu, Layers, Cog, Sparkles, Zap, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    id: "modelacao", icon: Cpu, title: "Modelação 3D",
    lead: "Desenvolvemos peças a partir de esboços, fotografias, medidas ou objetos existentes.",
    points: [
      "Desenvolvimento de peças",
      "Alteração de modelos existentes",
      "Preparação para impressão",
      "Modelação paramétrica",
      "Desenho técnico",
      "Otimização de componentes",
      "Engenharia inversa",
    ],
  },
  {
    id: "impressao", icon: Layers, title: "Impressão 3D",
    lead: "Produção de peças funcionais, técnicas e personalizadas com materiais selecionados.",
    points: [
      "Protótipos", "Peças funcionais", "Peças técnicas",
      "Produtos personalizados", "Pequenas séries",
      "Diferentes materiais e cores", "Vários níveis de acabamento",
    ],
  },
  {
    id: "prototipagem", icon: Cog, title: "Prototipagem",
    lead: "Validação rápida de conceito, encaixe e função. Desenvolvimento iterativo.",
    points: ["Validação de conceito", "Teste de encaixe", "Teste dimensional", "Teste funcional", "Iterações rápidas", "Produção de versões"],
  },
  {
    id: "desenvolvimento", icon: Sparkles, title: "Desenvolvimento de produto",
    lead: "Da ideia ao produto final. Um processo completo, transparente e acompanhado.",
    points: [
      "1. Recolha de requisitos", "2. Análise da ideia", "3. Modelação",
      "4. Apresentação", "5. Revisões", "6. Prototipagem", "7. Testes",
      "8. Aprovação", "9. Produção", "10. Entrega",
    ],
  },
  {
    id: "series", icon: Zap, title: "Pequenas séries",
    lead: "Produção por lotes sem investimento em moldes.",
    points: ["Produção sem moldes", "Menor investimento inicial", "Personalização", "Flexibilidade", "Alterações rápidas", "Reposição facilitada"],
  },
];

export default function Services() {
  return (
    <div className="anim-in">
      <div className="border-b border-border">
        <div className="container-x py-16 lg:py-24">
          <p className="tech-label mb-4">Serviços · cadditive</p>
          <h1 className="text-5xl lg:text-6xl font-bold tracking-tighter max-w-3xl">
            Fabrico aditivo <span className="text-brand">com método</span>.
          </h1>
          <p className="mt-6 text-lg text-muted-foreground max-w-2xl">
            Trabalhamos com particulares e empresas em todo o território nacional. Consulta os nossos serviços ou pede diretamente um orçamento.
          </p>
        </div>
      </div>

      {SERVICES.map((s, idx) => (
        <section key={s.id} id={s.id} className="border-b border-border">
          <div className="container-x py-16 lg:py-20 grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <div className="flex items-center gap-3">
                <s.icon size={28} className="text-brand" />
                <span className="mono text-xs uppercase tracking-widest text-muted-foreground">
                  0{idx + 1} · Serviço
                </span>
              </div>
              <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4">{s.title}</h2>
              <p className="mt-5 text-muted-foreground leading-relaxed">{s.lead}</p>
              <Link to="/pedido-orcamento" className="btn-primary mt-8" data-testid={`service-${s.id}-cta`}>
                Pedir orçamento <ArrowRight size={16} />
              </Link>
            </div>
            <div className="lg:col-span-7">
              <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3 border border-border p-8 crosshair-corners bg-card">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm">
                    <span className="text-brand mono">■</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
